import "./footer.css";
import React, { useState, useEffect } from "react";
import Long_logo_dark from "../../assets/ResiRent_Dark_Logo.png";
import useAuth from "../../hooks/useAuth";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import axios from "../../api/axios";
import useLogout from "../../hooks/useLogout";
import FooterContactInfo from "./FooterContactInfo";

import {
  accommodationFormDefaultDisplay,
  accFormDefaultEntries,
} from "../../languages/defaultEntries.js";
const WEBSITE_URL = "/pdf_url";
const WEBSITE_URL_NAME = "/dashboard/key";

// Adapt date automatically
// function formatDate(date) {
//   return new Intl.DateTimeFormat("en-US", { year: "numeric" }).format(date);
// }

export default function Footer() {
  const { auth, username } = useAuth();
  const { t, i18n } = useTranslation();

  const navigate = useNavigate();
  const title = "TandC";
  const logout = useLogout();

  const [showSpecialOffers, setShowSpecialOffers] = useState(true);
  const [showBlogs, setShowBlogs] = useState(true);

  const [TandCUrl, setTandCUrl] = useState(null);
  const [TC, setTC] = useState(0);

  const [nameAccommodation, setNameAccommodation] = useState("");
  const signIn = async () => {
    navigate("/login/");
  };

  const signOut = async () => {
    await logout();
    navigate("/");
  };

  useEffect(() => {
    async function fetch() {
      await axios
        .get(`${WEBSITE_URL}`, {
          params: { username, title },
        })
        .then((res) => {
          setTandCUrl(res.data);
        })
        .catch(function (error) {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
          }
          console.log(error.config);
        });
    }
    async function fetchName() {
      await axios
        .get(WEBSITE_URL_NAME, {
          params: {
            username: username,
            key: "nameAccommodation", // specify the column you want to retrieve
          },
        })
        .then((res) => {
          setNameAccommodation(res?.data?.nameAccommodation);
        });
    }
    async function fetchShowSpecialOffers() {
      await axios
        .get(WEBSITE_URL_NAME, {
          params: {
            username: username,
            key: "showSpecialOffers", 
          },
        })
        .then((res) => {
          setShowSpecialOffers(res?.data?.showSpecialOffers);
        });
    }async function fetchShowBlogs() {
      await axios
        .get(WEBSITE_URL_NAME, {
          params: {
            username: username,
            key: "showBlogs", 
          },
        })
        .then((res) => {
          setShowBlogs(res?.data?.showBlogs);
        });
    }
    async function fetchTC() {
      await axios
        .get(WEBSITE_URL_NAME, {
          params: {
            username: username,
            key: "tc", // specify the column you want to retrieve
          },
        })
        .then((res) => {
          setTC(res?.data?.tc);
        });
    }
    fetch();
    fetchName();
    fetchTC();
    fetchShowSpecialOffers();
    fetchShowBlogs();
  }, [username]);

  const accDefaultDisplay = accommodationFormDefaultDisplay;
  return (
    <div className="container-footer">
      <div className="container footer-new">
        <div className="footer-column">
          {!auth?.role ? (
            <div>
              <h2 className="footer-name">
                {nameAccommodation === accFormDefaultEntries.nameAccommodation
                  ? accDefaultDisplay.nameAccommodation
                  : nameAccommodation}
              </h2>

              <button className="book-now-btn" onClick={signIn} to="/login">
                {t("footer.login")}
              </button>
              {/* <LoginButton
                buttonText={t("footer.login")}
                onClick={signIn}
                href={"/login"}
              /> */}
            </div>
          ) : (
            <div>
              <button className="book-now-btn" onClick={signOut} to="/home">
                {t("footer.logout")}
              </button>
            </div>
          )}
        </div>
        <div className="footer-column">
          <h2>Page</h2>
          {t("nav_links", { returnObjects: true })
          .filter((item) => {
            if (item === "special-offers" && !showSpecialOffers) return false;
            if (item === "blog" && !showBlogs) return false;
            return true;
          })
          .map((item) => {
            const urlPath = item.toLowerCase().replace(/\s+/g, "-");

            // const capitalizedLabel = item
            //   .split(" ")
            //   .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            //   .join(" ");
            return (
              <li key={item}>
                <a className="footer-nav" href={`/${urlPath}`}>
                  {t(item)}
                </a>
              </li>
            );
          })}
        </div>
        <FooterContactInfo />
        <div className="footer-column">
          <div className="terms">
            {/* {TandCUrl && (
              <a className="suggestions-text" href={TandCUrl}>
                {t("footer.TC")}
              </a>
            )} */}
            {(() => {
              switch (i18n.language) {
                case "de":
                  return (
                    <>
                      <h2>Made by {i18n.language}</h2>
                      <a
                        className="logo-footer"
                        href="https://resirent.org/products/resirent-website"
                      >
                        <img src={Long_logo_dark} alt="ResiRent logo" />
                      </a>
                    </>
                  );
                case "nl":
                  return (
                    <>
                      <h2>Made by </h2>
                      <a
                        className="logo-footer"
                        href="https://resirent.org/nl/producten/resirent-website"
                      >
                        <img src={Long_logo_dark} alt="ResiRent logo" />
                      </a>
                    </>
                  );
                // Add more cases for other languages if needed
                default:
                  return (
                    <>
                      {/* <p href="https://resirent.org/de/produkte/resirent-website">
                        {/* &copy; {formatDate(year)} 
                      </p> */}
                      <h2>Made by</h2>
                      <a
                        className="logo-footer"
                        href="https://resirent.org/de/produkte/resirent-website"
                      >
                        <img src={Long_logo_dark} alt="ResiRent logo" />
                      </a>
                    </>
                  );
              }
            })()}
          </div>
          <div className="footer-text">
            Conscious hosting for thriving tourism{" "}
            <a className="footer-text" href="https://resirent.org/products/resirent-website">
               https://resirent.org/
            </a>{" "}
          </div>
        </div>
        <div className="footer-column mobile-only">
          <div className="footer-text">
            {TC === 0 && TandCUrl ? (
              <>
                <a className="footer-text" href={TandCUrl} target="_blank" rel="noopener noreferrer">
                  Terms and Conditions
                </a>{" "}
                |{" "}
                <a
                className="footer-text"
                  href="https://resirent.org/policies/terms"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  ©2025 All Rights Reserved
                </a>
              </>
            ) : (
              <>
                <a className="footer-text"  href="/terms" target="_blank" rel="noopener noreferrer">
                  Terms and Conditions
                </a>{" "}
                |{" "}
                <a
                  href="https://resirent.org/policies/terms"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  ©2025 All Rights Reserved
                </a>
              </>
            )}
          </div>
        </div>

        <div className="copyright mobile-no">
          <div className="footer-text">
            {TC === 0 && TandCUrl ? (
              <>
                <a className="footer-text" href={TandCUrl} target="_blank" rel="noopener noreferrer">
                  Terms and Conditions
                </a>{" "}
                |{" "}
                <a
                  className="footer-text"
                  href="https://resirent.org/policies/terms"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  ©2025 All Rights Reserved
                </a>
              </>
            ) : (
              <>
                <a className="footer-text" href="/terms" target="_blank" rel="noopener noreferrer">
                  Terms and Conditions
                </a>{" "}
                |{" "}
                <a
                  className="footer-text"
                  href="https://resirent.org/policies/terms"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  ©2025 All Rights Reserved
                </a>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
